import { NumberExt } from '../../util';
import { Point } from '../../geometry';
export function normalizePoint(bbox) {
  let args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return new Point(NumberExt.normalizePercentage(args.x, bbox.width), NumberExt.normalizePercentage(args.y, bbox.height));
}
export function toResult(point, angle, rawArgs) {
  return Object.assign({
    angle,
    position: point.toJSON()
  }, rawArgs);
}